import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from '@/routers/system/index.js'
Vue.use(VueRouter)
const _base = process.env.NODE_ENV == 'development' ? '' : '/spa'
export const router = new VueRouter({
  base: _base + '/system/',
  mode: 'history',
  routes
})

Vue.router = router

export default {
  router
}
